const auth = {
  brand: {
    alt: 'Quadralize Backoffice',
    name: 'Quadralize',
    product: 'Backoffice',
    badge: 'Backoffice',
  },
  layout: {
    defaultMarketingTitle: 'Central administrativa com controle total.',
    defaultMarketingDescription:
      'Acesso exclusivo ao backoffice para gerenciar unidades, permissões, integrações e operações sensíveis do ecossistema Quadralize.',
    highlightedPhrase: 'controle total',
  },
  login: {
    title: 'Acesso administrativo',
    description: 'Entre com suas credenciais corporativas para acessar o sistema interno.',
    emailLabel: 'E-mail',
    emailPlaceholder: 'seu@email.com',
    passwordLabel: 'Senha',
    passwordPlaceholder: '••••••••',
    forgotPassword: 'Esqueceu a senha?',
    submit: 'Entrar',
    restrictedAreaTitle: 'Área restrita',
    restrictedAreaDescription:
      'Este é um ambiente protegido. Todas as ações são registradas e auditadas.',
    validation: {
      passwordRequired: 'Senha obrigatória',
    },
    toast: {
      success: 'Login realizado com sucesso',
      error: 'Ocorreu um erro ao tentar realizar o login',
    },
  },
  forgotPassword: {
    marketingTitle: 'Recupere seu acesso rapidamente.',
    marketingDescription:
      'Não se preocupe, acontece com todos. Vamos te ajudar a recuperar o acesso à sua conta de forma rápida e segura.',
    title: 'Esqueceu sua senha?',
    description: 'Informe seu e-mail e enviaremos instruções para redefinir sua senha.',
    emailLabel: 'E-mail',
    emailPlaceholder: 'seu@email.com',
    submit: 'Enviar instruções',
    backToLogin: 'Voltar para o login',
    toast: {
      success: 'Código de recuperação enviado para o e-mail informado',
      error: 'Ocorreu um erro ao tentar recuperar a senha',
    },
  },
  verifyCode: {
    marketingTitle: 'Proteja sua conta com segurança.',
    marketingDescription:
      'Enviamos um código de 6 dígitos para o seu e-mail. Digite-o abaixo para continuar com a redefinição de senha.',
    title: 'Verifique seu código',
    description: 'Enviamos um código de verificação para {{email}}',
    codeLabel: 'Código de verificação',
    submit: 'Verificar código',
    resendPrompt: 'Não recebeu o código?',
    resend: 'Reenviar código',
    resending: 'Reenviando...',
    backToLogin: 'Voltar para o login',
    toast: {
      resendSuccess: 'Código reenviado com sucesso',
      resendError: 'Erro ao reenviar código',
      validateError: 'Erro ao validar código',
    },
  },
  resetPassword: {
    marketingTitle: 'Crie uma senha forte e segura.',
    marketingDescription:
      'Você está quase lá! Defina uma nova senha para sua conta e volte a acessar todos os recursos da plataforma.',
    title: 'Redefinir senha',
    description: 'Digite e confirme sua nova senha abaixo.',
    newPasswordLabel: 'Nova senha',
    newPasswordPlaceholder: 'Digite sua nova senha',
    confirmNewPasswordLabel: 'Confirmar nova senha',
    confirmNewPasswordPlaceholder: 'Digite novamente sua senha',
    submit: 'Redefinir senha',
    toast: {
      success: 'Senha redefinida com sucesso',
      error: 'Erro ao redefinir senha',
    },
  },
  activateAccount: {
    invalid: {
      marketingTitle: 'Link inválido.',
      marketingDescription:
        'O link de ativação que você acessou não é válido. Verifique seu e-mail e tente novamente.',
      badge: 'Link inválido',
      title: 'Link de ativação inválido',
      description:
        'O link de ativação que você acessou está incompleto ou inválido. Por favor, verifique seu e-mail e tente novamente.',
      goToLogin: 'Ir para o login',
    },
    success: {
      marketingTitle: 'Conta ativada com sucesso!',
      marketingDescription:
        'Sua conta foi ativada e está pronta para uso. Agora você pode acessar o backoffice com suas credenciais.',
      badge: 'Conta ativada',
      titleWithName: 'Tudo pronto, {{name}}!',
      titleWithoutName: 'Tudo pronto!',
      description: 'Sua conta foi ativada com sucesso. Agora você pode acessar o backoffice.',
      goToBackoffice: 'Acessar o backoffice',
    },
    form: {
      marketingTitle: 'Defina sua senha de acesso.',
      marketingDescription:
        'Crie uma senha segura para ativar sua conta e começar a utilizar o backoffice Quadralize.',
      titleWithName: 'Bem-vindo, {{name}}!',
      titleWithoutName: 'Ativar conta',
      description: 'Defina uma senha para ativar sua conta de administrador.',
      passwordLabel: 'Senha',
      passwordPlaceholder: 'Digite sua senha',
      confirmPasswordLabel: 'Confirmar senha',
      confirmPasswordPlaceholder: 'Digite novamente sua senha',
      submit: 'Ativar conta',
    },
    toast: {
      error: 'Erro ao ativar a conta',
    },
  },
  theme: {
    toggle: 'Alternar tema',
  },
}

export default auth
